
<p-tree [value]="files" selectionMode="checkbox" class="w-full md:w-30rem" [(selection)]="selectedFiles"></p-tree>
<div class="border-top-3 border-blue-600"></div>
<div style="margin-top: 5px; text-align: end;">
    <p-button icon="pi pi-check" label="Save" id="save"styleClass="p-button-success p-button-raised" (onClick)="selectedMilestoneMethod()"></p-button>
</div>
